import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CongressSelectorService } from '../services/congress-selector.service';

/**
 * Route racine '' : charge la liste des congrès puis redirige vers l'édition par défaut.
 * À chaîner après authGuard. Back en panne pendant le chargement => /unavailable (une seule
 * requête). Aucune édition : un admin part sur /admin, les autres comptes sur la page d'attente,
 * que pendingGuard leur laisse dans ce cas (sinon « » et /pending se renverraient la balle).
 */
export const congressRedirectGuard: CanActivateFn = async () => {
  const congress = inject(CongressSelectorService);
  const auth = inject(AuthService);
  const router = inject(Router);

  await congress.load();
  if (!auth.backendReachable()) {
    return router.createUrlTree(['/unavailable']);
  }
  const id = congress.defaultId();
  if (id) {
    return router.createUrlTree([id]);
  }
  return router.createUrlTree([auth.isAdmin() ? '/admin' : '/pending']);
};
